var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navBar"},[_c('Notification',{staticClass:"header-tool"}),_c('UserAbility',{staticClass:"header-tool user-ability"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }